import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import {
  Alert,
  Button,
  Checkbox,
  Col,
  Form,
  Icon,
  InputNumber,
  Input,
  message,
  Row,
  Upload, Badge,
} from "antd";
import { withNamespaces } from "react-i18next";
import classes from "./WizardConfig.css";

import { postConsentConfig } from "../../api/requests";
import { logout, setAppSettings } from "../../reducers/user/actions";

class ConsentConfigForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      consentConfigData: {},
      isLoadingData: false,
      isLoading: false,
      drugDosageSettingsKeys: [],
      drugDosageSettingsValues: {},
      randomizationData: null,
      errorMessage: null,
    };
  }

  componentDidMount() {
    this.setData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.consentConfigData.is_configured !==
      this.props.consentConfigData.is_configured
    ) {
      this.setData();
    }
  }

  setData = () => {
    this.setState({
      consentConfigData: this.props.consentConfigData,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({
      errorMessage: null,
    });
    this.props.form.validateFields(async (err, values) => {
      const data = { ...values };

      this.props.form.setFields({
        pre_randomization_consent: {
          value: values.pre_randomization_consent,
          errors: null,
        },
        pre_randomization_email_consent: {
          value: values.pre_randomization_email_consent,
          errors: null,
        },
        allow_recording_consent_by_user_id: {
          value: values.allow_recording_consent_by_user_id,
          errors: null,
        },
        password_required: { value: values.password_required, errors: null },
        limit_consent_to_subject_site: {
          value: values.limit_consent_to_subject_site,
          errors: null,
        },
      });

      try {
        const formData = new FormData();
        formData.append("tst_client", values.tst_client);
        formData.append("key_passphrase", values.key_passphrase);
        formData.append("pre_randomization_consent", values.pre_randomization_consent);
        formData.append("pre_randomization_email_consent", values.pre_randomization_email_consent);
        formData.append("allow_recording_consent_by_user_id", values.allow_recording_consent_by_user_id);
        formData.append("password_required", values.password_required);
        formData.append("limit_consent_to_subject_site", values.limit_consent_to_subject_site);
        formData.append("consent_email_expiration_hours", values.consent_email_expiration_hours);

        if (values.cert_key && values.cert_key.file) {
          formData.append("cert_key", values.cert_key.file);
        }
        if (values.cert_file && values.cert_file.file) {
          formData.append("cert_file", values.cert_file.file);
        }


        await postConsentConfig(formData);
        message.success(this.props.i18n.t("Saved"));
        this.props.setAppSettings();
        this.props.onSubmit();
      } catch (e) {
        if (get(e, "response.data.errors")) {
          const errors = {};
          Object.keys(get(e, "response.data.errors")).forEach(
            (errorFieldKey) => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                  (errorMessage) => new Error(errorMessage)
                ),
              };
            }
          );
          this.props.form.setFields(errors);
        } else {
          this.setState({
            errorMessage: JSON.stringify(get(e, "response.data.errors")),
          });
        }
        message.error(this.props.i18n.t("Error"));
        console.log(e);
      }
    });
  };

  render() {
    const {
      consentConfigData,
      isLoading,
      isLoadingData,
      errorMessage,
    } = this.state;
    const { randomizationData, isDisabled } = this.props;
    const { getFieldDecorator } = this.props.form;
    const isRandomizeConfig =
      get(randomizationData, "treatment_groups", []).length > 0;
    const isEditable = isRandomizeConfig;

    return (
      <div className={classes.formWrapper}>
        <h3 className="headline-default">
          {this.props.i18n.t("NamespaceWizardConfig:Consent Config")}
        </h3>

        {!isLoadingData ? (
          <Form onSubmit={this.handleSubmit}>
            <Row gutter={8}>
              <Col sm={24}>
                {!isRandomizeConfig && (
                  <Alert
                    type="warning"
                    message={this.props.i18n.t(
                      "NamespaceWizardConfig:Please fill Randomization Config first"
                    )}
                  />
                )}
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={24}>
                <div>
                  <Form.Item>
                    {getFieldDecorator("pre_randomization_consent", {
                      initialValue: get(
                        consentConfigData,
                        "pre_randomization_consent",
                        false
                      ),
                      valuePropName: "checked",
                    })(
                      <Checkbox disabled={!isEditable || isDisabled}>
                        <span style={{ fontSize: "16px" }}>
                          {this.props.i18n.t(
                            "NamespaceWizardConfig:Pre randomization consent"
                          )}
                        </span>
                      </Checkbox>
                    )}
                  </Form.Item>
                </div>
              </Col>
              <Col sm={24}>
                <div>
                  <Form.Item>
                    {getFieldDecorator("pre_randomization_email_consent", {
                      initialValue: get(
                        consentConfigData,
                        "pre_randomization_email_consent",
                        false
                      ),
                      valuePropName: "checked",
                    })(
                      <Checkbox disabled={!isEditable || isDisabled}>
                        <span style={{ fontSize: "16px" }}>
                          {this.props.i18n.t(
                            "NamespaceWizardConfig:Allow pre randomization consent via email"
                          )}
                        </span>
                      </Checkbox>
                    )}
                  </Form.Item>
                </div>
              </Col>
              <Col sm={24}>
                <div>
                  <Form.Item>
                    {getFieldDecorator("allow_recording_consent_by_user_id", {
                      initialValue: get(
                        consentConfigData,
                        "allow_recording_consent_by_user_id",
                        false
                      ),
                      valuePropName: "checked",
                    })(
                      <Checkbox disabled={!isEditable || isDisabled}>
                        <span style={{ fontSize: "16px" }}>
                          {this.props.i18n.t(
                            "NamespaceWizardConfig:Allow recording consent by user id"
                          )}
                        </span>
                      </Checkbox>
                    )}
                  </Form.Item>
                </div>
              </Col>
              <Col sm={24}>
                <div>
                  <Form.Item>
                    {getFieldDecorator("password_required", {
                      initialValue: get(
                        consentConfigData,
                        "password_required",
                        false
                      ),
                      valuePropName: "checked",
                    })(
                      <Checkbox disabled={!isEditable || isDisabled}>
                        <span style={{ fontSize: "16px" }}>
                          {this.props.i18n.t(
                            "NamespaceWizardConfig:Require password"
                          )}
                        </span>
                      </Checkbox>
                    )}
                  </Form.Item>
                </div>
              </Col>
              <Col sm={24}>
                <div>
                  <Form.Item>
                    {getFieldDecorator("limit_consent_to_subject_site", {
                      initialValue: get(
                        consentConfigData,
                        "limit_consent_to_subject_site",
                        false
                      ),
                      valuePropName: "checked",
                    })(
                      <Checkbox disabled={!isEditable || isDisabled}>
                        <span style={{ fontSize: "16px" }}>
                          {this.props.i18n.t(
                            "NamespaceWizardConfig:Limit consent to subject site"
                          )}
                        </span>
                      </Checkbox>
                    )}
                  </Form.Item>
                </div>
              </Col>
              <Col sm={24}>
                <b>
                  {this.props.i18n.t(
                    "NamespaceWizardConfig:Consent email expiration hours"
                  )}
                </b>
                <div style={{ margin: "0 0 30px", width: "250px" }}>
                  {getFieldDecorator("consent_email_expiration_hours", {
                    rules: [
                      {
                        required: true,
                        message: this.props.i18n.t("Required"),
                      },
                    ],
                    initialValue: get(
                      consentConfigData,
                      "consent_email_expiration_hours"
                    ),
                  })(<InputNumber disabled={!isEditable || isDisabled} />)}
                </div>
              </Col>
              <Col sm={24}>
                <b>{this.props.i18n.t("NamespaceWizardConfig:Time stamp server client URL")}</b>
                {(get(consentConfigData, "tst_client") &&
                  get(consentConfigData,"key_passphrase_is_set")&&
                  get(consentConfigData,"cert_key")&&
                  get(consentConfigData,"cert_file")) &&

                  (<i>{" "}<span style={{
                      color: "rgba(73,200,80,0.44)",
                    }}>SIGNING ACTIVE</span> (Remove this value to disable digital signing)</i>)
                }
                <br/>
                <div style={{margin: "0 0 30px", width: "250px"}}>
                  {getFieldDecorator("tst_client", {
                    // rules: [
                    //   {
                    //     required: true,
                    //     message: this.props.i18n.t("Required"),
                    //   },
                    // ],
                    initialValue: get(consentConfigData, "tst_client"),
                  })(<Input disabled={!isEditable || isDisabled}/>)}
                </div>
              </Col>
              <Col sm={24}>
                <b>
                  {this.props.i18n.t("NamespaceWizardConfig:Key passphrase for cert file")}

                  <Badge
                    count={
                      get(
                          consentConfigData,
                          "key_passphrase_is_set"
                      )
                        ? this.props.i18n.t("is set")
                        : this.props.i18n.t("not set")
                    }
                    style={{
                      backgroundColor: get(
                        consentConfigData,
                        "key_passphrase_is_set"
                    )
                        ? "rgba(73,200,80,0.44)"
                        : "#999",
                    }}
                  />
                </b>
                <div style={{ margin: "0 0 30px", width: "250px" }}>
                  {getFieldDecorator("key_passphrase", {
                    // rules: [
                    //   {
                    //     required: true,
                    //     message: this.props.i18n.t("Required"),
                    //   },
                    // ],
                    initialValue: '',
                  })(<Input.Password autocomplete="new-password" disabled={!isEditable || isDisabled} />)}
                </div>
              </Col>
              <Col sm={24}>
                <b>{this.props.i18n.t("Cert Key (.pem)")}
                  <Badge
                    count={
                      get(
                          consentConfigData,
                          "cert_key"
                      )
                        ? this.props.i18n.t("is set")
                        : this.props.i18n.t("not set")
                    }
                    style={{
                      backgroundColor: get(
                        consentConfigData,
                        "cert_key"
                    )
                        ? "rgba(73,200,80,0.44)"
                        : "#999",
                    }}
                  />
                </b>
                <br/>
                {get(
                          consentConfigData,
                          "cert_key"
                      ) &&
                  <i>{get(
                          consentConfigData,
                          "cert_key"
                      )}</i>}
                <Form.Item>
                  {getFieldDecorator("cert_key", {
                    initialValue: get(consentConfigData, "cert_key"),
                  })(
                    <Upload
                      disabled={!isEditable}
                      action=""
                      beforeUpload={() => false}
                      multiple={false}
                      fileList={get(
                        this.props.form.getFieldValue("cert_key"),
                        "fileList",
                        []
                      ).slice(-1)}
                    >
                      <Button>
                        <Icon type="upload" />
                        {!get(consentConfigData, "cert_key") &&
                        this.props.url
                          ? this.props.i18n.t("Change file")
                          : this.props.i18n.t("NamespaceDrugForm:Cert Key")}
                      </Button>
                    </Upload>
                  )}
                </Form.Item>
              </Col>
              <Col sm={24}>
                <b>{this.props.i18n.t("Cert File (.pem)")}

                  <Badge
                    count={
                      get(
                        consentConfigData,
                        "cert_file"
                      )
                        ? this.props.i18n.t("NamespaceWizardConfig:Is set")
                        : this.props.i18n.t("NamespaceWizardConfig:not set")
                    }
                    style={{
                      backgroundColor: get(
                        consentConfigData,
                        "cert_file"
                      )
                        ? "rgba(73,200,80,0.44)"
                        : "#999",
                    }}
                  />
                </b>
                <br/>
                {get(
                    consentConfigData,
                    "cert_file"
                  ) &&
                  <i>{get(
                    consentConfigData,
                    "cert_file"
                  )}</i>}
                <Form.Item>
                  {getFieldDecorator("cert_file", {
                    initialValue: get(consentConfigData, "cert_file"),
                  })(
                    <Upload
                      disabled={!isEditable}
                      action=""
                      beforeUpload={() => false}
                      multiple={false}
                      fileList={get(
                        this.props.form.getFieldValue("cert_file"),
                        "fileList",
                        []
                      ).slice(-1)}
                    >
                      <Button>
                        <Icon type="upload"/>
                        {!get(consentConfigData, "cert_file") &&
                        this.props.url
                          ? this.props.i18n.t("Change file")
                          : this.props.i18n.t("NamespaceDrugForm:Cert File")}
                      </Button>
                    </Upload>
                  )}
                </Form.Item>
              </Col>
            </Row>

            <br />
            <Row gutter={8}>
              {errorMessage && (
                <Col span={24}>
                  <Alert message={errorMessage} type="error" />
                </Col>
              )}
              <Col span={24}>
                <Button
                  disabled={!isEditable || isDisabled}
                  type="primary"
                  size="large"
                  htmlType="submit"
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
              </Col>
            </Row>
          </Form>
        ) : (
          <Icon type="loading" />
        )}
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { setAppSettings, logout };

export default Form.create({ name: "ConsentConfigForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(ConsentConfigForm))
);



// WEBPACK FOOTER //
// ./src/containers/WizardConfig/ConsentConfigForm.js